// TODO: move this file to common api!
angular.module('zc.commonApi')
  .factory('Agency', Agency);

Agency.$inject = ['$q', 'Api'];
function Agency($q, Api) {
  const service = {
    all,
    get,
    update,
    getAgencyColor,
    getAgencyName
  };

  return service;

  function all() {
    return Api.get('/api/agencies', {}, {cache: false})
      .then(res => {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.agencies;
      });
  }

  function get(name) {
    return Api.get(`/api/agencies/${name}`, {}, {cache: false})
      .then(res => {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.agency;
      });
  }

  function update(params) {
    return Api.patch(`/api/agencies/name:${params.name}`, params, {cache: false});
  }

  function getAgencyColor(id) {
    return 'list-item-avatar' + (id % 15);
  }

  function getAgencyName(agencyName) {
    return agencyName;
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/agency.service.js